export default __webpack_public_path__ + "static/media/mc-p-card.74a2ce7d.png";